import appConfig from '../../configs/appConfig.js';
import connectionTypes from '../../consts/connectionTypes.js';
import deviceNavigationMenuTypes from '../../consts/home/deviceNavigationMenuTypes';
import routes from '../../consts/routes';
import {selectIsAuthorized} from '../../state/selectors/auth';
import {selectIsAgeGateConfirmed, selectIsGetStartedPageShown, selectIsPWA} from '../../state/selectors/global';
import {
    selectInitialConnectionType,
    selectIsMandatoryConsentsAccepted,
    selectIsPushNotificationPageVisible,
    selectShouldRedirectToHome,
} from '../../state/selectors/session';
import {setActiveDeviceNavigationMenuType, setIsHomeMenuExpanded} from '../../state/slice/session';
import {dispatch, getState} from '../../state/store';
import storageService from '../storageService';
import {userBrowserService} from '../userBrowserService';

const getInitRouteRules = (state) => {
    return [
        {condition: () => !userBrowserService.getIsBrowserCompatible(), route: routes.UNSUPPORTED_BROWSER},
        {condition: () => appConfig.getIsDashboardEnabled(), route: routes.RETAIL_DASHBOARD},
        {condition: () => selectIsPWA(state), route: routes.CLUB_WELCOME},
        {condition: () => !selectIsAgeGateConfirmed(state), route: routes.AGE_GATE},
        {condition: () => !selectIsGetStartedPageShown(state), route: routes.GET_STARTED_PAGE},
        {condition: () => getIsInstallationGuideVisible(), route: routes.APP_INSTALLATION_GUIDE},
        {condition: () => !selectIsAuthorized(state), route: routes.PRE_LOGIN},
        {condition: () => !selectIsMandatoryConsentsAccepted(state), route: routes.TERMS_OF_USE},
        {condition: () => selectIsPushNotificationPageVisible(state), route: routes.PUSH_NOTIFICATIONS},
        {condition: () => selectShouldRedirectToHome(state), route: routes.HOME},
    ];
};

const getConnectionGuideIntroRoute = () => {
    const connectionType = selectInitialConnectionType(getState());

    return connectionType === connectionTypes.WIFI
        ? routes.WIFI_CONNECTION_GUIDE_INTRO
        : connectionType === connectionTypes.CELLULAR
        ? routes.LTE_CONNECTION_GUIDE_INTRO
        : connectionType === connectionTypes.SIDEWALK
        ? routes.SIDEWALK_CONNECTION_GUIDE_INTRO
        : routes.WIFI_CONNECTION_GUIDE_INTRO;
};

const getConnectionGuideStepsRoute = () => {
    const connectionType = selectInitialConnectionType(getState());

    return connectionType === connectionTypes.WIFI
        ? routes.WIFI_CONNECTION_GUIDE_STEPS
        : connectionType === connectionTypes.CELLULAR
        ? routes.LTE_CONNECTION_GUIDE_STEPS
        : connectionType === connectionTypes.SIDEWALK
        ? routes.SIDEWALK_CONNECTION_GUIDE_STEPS
        : routes.WIFI_CONNECTION_GUIDE_INTRO;
};

const getIsInstallationGuideVisible = () => {
    const isPWA = selectIsPWA(getState());
    const wasInstallationGuideShown = storageService.getWasInstallationGuideShown();

    return !isPWA && !wasInstallationGuideShown;
};

const getHomePageRoute = () => (appConfig.getIsDashboardEnabled() ? routes.RETAIL_DASHBOARD : routes.CLUB_WELCOME);

const getInsightRoute = () => {
    dispatch(setActiveDeviceNavigationMenuType(deviceNavigationMenuTypes.INSIGHT));
    dispatch(setIsHomeMenuExpanded(true));

    return routes.HOME;
};

const getPersonaliseRoute = () => {
    dispatch(setActiveDeviceNavigationMenuType(deviceNavigationMenuTypes.PERSONALISE));
    dispatch(setIsHomeMenuExpanded(true));

    return routes.HOME;
};

const handleQuickGuideRoute = () => {
    if (appConfig.getIsAppearanceEnabled()) {
        return routes.APPEARANCE;
    }

    if (appConfig.getIsFlexBatteryEnabled()) {
        return routes.FLEX_BATTERY;
    }

    return routes.HOME;
};

export default {
    getInitRouteRules,
    getConnectionGuideIntroRoute,
    getConnectionGuideStepsRoute,
    getIsInstallationGuideVisible,
    getHomePageRoute,
    getInsightRoute,
    getPersonaliseRoute,
    handleQuickGuideRoute,
};
